import { Tooltip } from "@mui/material";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { useUserStore } from "../hooks/store";
import { getLog } from "../utils/API/userMethod";
import SolvingHistoryGrid from "./SolvingHistoryGrid/SolvingHistoryGrid";
import { useModal } from "../hooks/modalStore";
import Styles from "./ExamCard/examCard.module.css";

export default function SolvingHistoryButton({
  biletId,
  themeId,
  type,
  title,
  questions,
}) {
  const userStore = useUserStore();
  const modalStore = useModal();
  const historyHandleClick = () => {
    getLog(biletId, themeId, type).then(({ data, staus }) => {
      modalStore.handleOpen(
        <SolvingHistoryGrid title={title} logData={data} />
      );
    });
  };
  return (
    <Tooltip
      placement="top"
      title={"История решений"}
      sx={{ transition: "inherit !important" }}>
      <HistoryRoundedIcon
        className={`${!userStore.isAuth && Styles.disabled_history}`}
        onClick={historyHandleClick}
      />
    </Tooltip>
  );
}
